import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { DriftsMeddelelse } from './driftsmeddelelse.model';

@Injectable({
  providedIn: 'root',
})
export class DriftsMeddelelserApi extends RestApi<DriftsMeddelelse> {
  override endpoint = '/api/admin/driftsmeddelelser';
}
